import { useMemo } from 'react';

import { isAgentProxyMode } from '@/utils/agent-proxy';

import { useAppConfig } from './use-app-config';

/**
 * Hook to check if the application is running in Agent Proxy mode.
 * Returns stable boolean that can be used for conditional rendering.
 *
 * In Agent Proxy mode:
 * - CloudProxy injects Authorization headers at the network layer
 * - UI uses mock user from app config instead of Auth0
 * - AccessSelector (login/logout/view-only) should be hidden
 * - Environment banner should be hidden
 */
export const useAgentProxyMode = () => {
  const { data: appConfig, isLoading } = useAppConfig();

  return useMemo(
    () => ({
      isAgentProxyMode: appConfig ? isAgentProxyMode(appConfig) : false,
      isLoading,
    }),
    [appConfig, isLoading]
  );
};
